import { config as commonConfig } from '@febos-io/common';
import { config as designConfig } from '@febos-io/design';
import { config as authConfig } from '@febos-io/auth';

designConfig.configureIcons(
  commonConfig.ICONS,
  authConfig.ICONS
);
